import React, { useEffect, useState, useRef } from "react";
import style from "./HealthStatus.module.scss";
import { Cross, LockSvg, Pencil, PendingLockSvg, Tick } from "../../../modules/default-svg";
import TextArea from "../../../components/controls/textarea/Textarea";
import { Tooltip } from "@fluentui/react-components";

const StatusItem = (props) => {
    const { item: items, updateStatus, disabled, isGlobal = false } = props;
    const [readOnly, setReadonly] = useState(true);
    const [isActive, setIsActive] = useState(false);
    const [isActiveForecast, setIsActiveForecast] = useState(false);
    const [selected, setSelected] = useState();
    const [selectedForecast, setSelectedForecast] = useState();
    const [description, setDescription] = useState('');
    const containerRef = useRef(null);
    
    useEffect(() => {
        if (readOnly === false) {
          setTimeout(() => {
                if (containerRef.current) {
                    const textarea = containerRef.current.querySelector('textarea');
                    if (textarea) {
                        textarea.focus();
                    }
                }              
          }, 100);
        }
    }, [readOnly]);

    const getType = (isForecast = 0) => {
        var selectedItem = isForecast === 0 ? selected : selectedForecast;
        switch (selectedItem) {
            case 1: return 'Monitoring';
            case 2: return 'Slipping';
            default: return 'On Target';
        }
    }
    const getStatusType = (isForecast = 0) => {
        var selectedItem = isForecast === 0 ? selected : selectedForecast;
        switch (selectedItem) {
            case 1: return `${style.HsOffTrack}`;
            case 2: return `${style.HsAtRisk}`;
            default: return `${style.HsOnTrack}`;
        }
    }

    const handleClick = (e, item, status) => {
        e.preventDefault();
        if(!item.isForecast){
            setSelected(status);
            setIsActive(!isActive);
        }
        else{
            setSelectedForecast(status);
            setIsActiveForecast(!isActiveForecast);
        }

        const payload = {
            description: item.description,
            kpi: item.kpi,
            period: item.period,
            status: status,
            isForecast: item.isForecast
        }
        updateStatus(payload);
    }

    const handleDescription = (value) => {
        if (value.length <= 250) {
            setDescription(value);
        }
    }

    const handleConfirm = () => {
        const payload = {
            description: description,
            kpi: items[0].kpi,
            period: items[0].period,
            status: selected,
        }
        updateStatus(payload);
        setReadonly(true);
    }

    const handleCancel = () => {
        setReadonly(true);
        items[0].description ? setDescription(items[0].description) : setDescription("");
    }

    useEffect(() => {
        if (items && items.length > 0) {
            setSelected(items[0].status);
            setSelectedForecast(items[1].status);
            setDescription(items[0].description);
        }
    }, [items])

    return (
        <>
        {
            !isGlobal ?
            <div className="col-12">
                <div className={style.rowsFlex}>
                    <div className="flex col-2">
                        <div className="w-50">
                            <div className= {`${style.dropDowanContainer} ${disabled ? style.disabledContainer : ''}`}>
                                <div className="position-relative" disabled>
                                    <div onClick={(e) => { setIsActive(!isActive) }} className={`${style.dropdown_btn} ${getStatusType(0)} text-xsm-600`}>
                                        {getType(0)}
                                        <span className={isActive ? "fas fa-caret-up" : "fas fa-caret-down"} />
                                    </div>

                                    <div className={style.dropdown_content} style={{ display: isActive ? "block" : "none" }}>
                                        <div className={`${style.dropDownitem} text-xsm-400`} onClick={(e) => handleClick(e, items[0], 0)}>
                                            <span className={`${style.HsOnTrack} ${style.radioBOx}`}></span>
                                            <span className="text-xsm-400">On Target</span>
                                        </div>
                                        <div className={`${style.dropDownitem} `} onClick={(e) => handleClick(e, items[0], 1)}>
                                            <span className={`${style.HsOffTrack} ${style.radioBOx}`}></span>
                                            <span className="text-xsm-400">Monitoring</span>
                                        </div>
                                        <div className={`${style.dropDownitem} text-xsm-400`} onClick={(e) => handleClick(e, items[0], 2)}>
                                            <span className={`${style.HsAtRisk} ${style.radioBOx}`}></span>
                                            <span className="text-xsm-400">Slipping</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-50">
                            <div className={`${style.dropDowanContainer} ${disabled ? style.disabledContainer : ''}`}>
                                <div className="position-relative">
                                    <div onClick={(e) => { setIsActiveForecast(!isActiveForecast) }} className={`${style.dropdown_btn} ${getStatusType(1)} text-xsm-600`}>
                                        {getType(1)}
                                        <span className={isActiveForecast ? "fas fa-caret-up" : "fas fa-caret-down"} />
                                    </div>
                                    <div className={style.dropdown_content} style={{ display: isActiveForecast ? "block" : "none" }}>
                                        <div className={`${style.dropDownitem} text-xsm-400`} onClick={(e) => handleClick(e, items[1], 0)}>
                                            <span className={`${style.HsOnTrack} ${style.radioBOx}`}></span>
                                            <span className="text-xsm-400">On Target</span>
                                        </div>
                                        <div className={`${style.dropDownitem} `} onClick={(e) => handleClick(e, items[1], 1)}>
                                            <span className={`${style.HsOffTrack} ${style.radioBOx}`}></span>
                                            <span className="text-xsm-400">Monitoring</span>
                                        </div>
                                        <div className={`${style.dropDownitem} text-xsm-400`} onClick={(e) => handleClick(e, items[1], 2)}>
                                            <span className={`${style.HsAtRisk} ${style.radioBOx}`}></span>
                                            <span className="text-xsm-400">Slipping</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-10">
                        <div className={`${style.statusEditPane} ${disabled ? style.disabledContainer : ''}`}>
                            <div ref={containerRef} className="d-flex align-items-center justify-content-between h-100">
                                {readOnly &&
                                (
                                <button type="button" className={style.editbtnstext} onClick={() => setReadonly(false)}>
                                    <Pencil />
                                </button>
                                )
                                }
                                <div className={`${style.fixedWidthContent} `}>
                                    <TextArea 
                                        textAreaFieldSize="text-styling p-0" 
                                        value={description} 
                                        onChange={((e) => handleDescription(e))} 
                                        placeholder="" 
                                        readonly={readOnly}
                                        handleKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleConfirm();
                                            }
                                        }}
                                        />
                                </div>                        
                            </div>
                            {!readOnly && (
                                <p className="text-xxsm-400 AvatarColor">
                                    {`${description.length}/250 Characters`}
                                </p>
                            )}
                            {!readOnly && (
                                <div className="position-edit-btns">
                                    <button type="button" className="edit-btns" onClick={handleConfirm}>
                                        <Tick />
                                    </button>
                                    <button type="button" className="edit-btns" onClick={handleCancel}>
                                        <Cross />
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            :
            <>
                <div className={`${style.rowsFlex} ${style.isGlobal}`}>      
                    <div className="flex align-items-center">
                        <Tooltip content="Global Health Status - Current" relationship="label">
                            <div className="w-50">
                                <div className= {`${style.dropDowanContainer} ${disabled ? style.disabledContainer : ''}`}>
                                    <div className="position-relative" disabled>
                                        <div onClick={(e) => { setIsActive(!isActive) }} className={`${style.dropdown_btn} ${getStatusType(0)} text-xsm-600`}>
                                            {getType(0)}
                                            <span className={isActive ? "fas fa-caret-up" : "fas fa-caret-down"} />
                                        </div>

                                        <div className={style.dropdown_content} style={{ display: isActive ? "block" : "none" }}>
                                            <div className={`${style.dropDownitem} text-xsm-400`} onClick={(e) => handleClick(e, items[0], 0)}>
                                                <span className={`${style.HsOnTrack} ${style.radioBOx}`}></span>
                                                <span className="text-xsm-400">On Target</span>
                                            </div>
                                            <div className={`${style.dropDownitem} `} onClick={(e) => handleClick(e, items[0], 1)}>
                                                <span className={`${style.HsOffTrack} ${style.radioBOx}`}></span>
                                                <span className="text-xsm-400">Monitoring</span>
                                            </div>
                                            <div className={`${style.dropDownitem} text-xsm-400`} onClick={(e) => handleClick(e, items[0], 2)}>
                                                <span className={`${style.HsAtRisk} ${style.radioBOx}`}></span>
                                                <span className="text-xsm-400">Slipping</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Tooltip>
                        <Tooltip content="Global Health Status - Trending" relationship="label">
                        <div className="w-50">
                            <div className={`${style.dropDowanContainer} ${disabled ? style.disabledContainer : ''}`}>
                                <div className="position-relative">
                                    <div onClick={(e) => { setIsActiveForecast(!isActiveForecast) }} className={`${style.dropdown_btn} ${getStatusType(1)} text-xsm-600`}>
                                        {getType(1)}
                                        <span className={isActiveForecast ? "fas fa-caret-up" : "fas fa-caret-down"} />
                                    </div>
                                    <div className={style.dropdown_content} style={{ display: isActiveForecast ? "block" : "none" }}>
                                        <div className={`${style.dropDownitem} text-xsm-400`} onClick={(e) => handleClick(e, items[1], 0)}>
                                            <span className={`${style.HsOnTrack} ${style.radioBOx}`}></span>
                                            <span className="text-xsm-400">On Target</span>
                                        </div>
                                        <div className={`${style.dropDownitem} `} onClick={(e) => handleClick(e, items[1], 1)}>
                                            <span className={`${style.HsOffTrack} ${style.radioBOx}`}></span>
                                            <span className="text-xsm-400">Monitoring</span>
                                        </div>
                                        <div className={`${style.dropDownitem} text-xsm-400`} onClick={(e) => handleClick(e, items[1], 2)}>
                                            <span className={`${style.HsAtRisk} ${style.radioBOx}`}></span>
                                            <span className="text-xsm-400">Slipping</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </Tooltip>
                        {disabled ? <LockSvg/>: 
                        <PendingLockSvg
                            toolipText="This period is scheduled to be locked at the end of the week (Sunday). Ensure all necessary updates are completed before then."
                        />
                        }
                    </div>
                </div>
            </>
        }
            
        </>
    )
}

export default StatusItem;